module.exports = __webpack_public_path__ + "static/media/layout-1.a4629b63.jpg";